<template>
  <o-view class="c-sales-view" :has-white-background="true" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar
        title="Cambio-inschrijving"
        :has-back-button="true"
        :has-close-button="true"
        :is-overlay="true"
      />
      <o-section-header title="Rijbewijs">
        <template #right>
          <o-icon icon="info" @click.native="showOverlay('info')" />
        </template>
      </o-section-header>
      <o-section>
        <p>
          Voeg hier een foto toe van de voorzijde en achterzijde van je
          rijbewijs.
        </p>
        <o-picture-uploader label="Voorkant" />
        <o-picture-uploader label="Achterkant" />
      </o-section>
      <o-overlay ref="info">
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut
          consectetur accumsan libero. Nullam quis elit at metus viverra tempor.
          Vivamus metus magna, dapibus at lacus et, tincidunt cursus tellus.
        </p>
      </o-overlay>
    </o-view>
    <o-pay-button
      label="Verder"
      to="/sales/car/cambio/onboarding/confirmation"
    />
  </o-view>
</template>

<script>
import OFavoriteToggle from '@/components/OFavoriteToggle.vue'
import OHeaderImage from '@/components/OHeaderImage.vue'
import OPayButton from '@/components/OPayButton.vue'
import OPictureUploader from '@/components/OPictureUploader.vue'
export default {
  name: 'CambioCurrent',
  components: {
    OFavoriteToggle,
    OHeaderImage,
    OPayButton,
    OPictureUploader
  },
  data() {
    return {
      pin: '• • • •'
    }
  },
  methods: {
    showPin() {
      this.pin = '4321'
    }
  }
}
</script>

<style lang="scss">
.c-sales-view {
  display: flex;
  flex-direction: column;
  min-height: 100%;

  .c-sales-sections {
    flex: 1 0 auto;
  }
}

.c-sales-details {
  padding: 0.8rem 0;
  position: relative;

  &:not(:last-child) {
    margin-bottom: 1.6rem;
  }
}

.c-sales-details__left,
.c-sales-details__right {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.c-sales-details__right {
  right: 0;
}

.c-sales-details__center {
  text-align: center;
}

.c-mobility-points {
  align-items: center;
  display: flex;
}

.c-mobility-points__icon {
  color: $primary-color;
  color: var(--primary-color);
}

.c-mobility-points__value {
  font-size: 1.3rem;
  margin-left: 0.8rem;
}

.c-price {
  color: $primary-color;
  color: var(--primary-color);
  font-size: 3.2rem;
  font-weight: 600;
  line-height: 3.2rem;
}

.c-price__sign {
  color: $gray-500;
  font-weight: 300;
  margin-right: 0.8rem;
}

.c-service {
  color: $gray-500;
  font-size: 1.3rem;
  margin-top: 0.8rem;
}
</style>
